import httpClient from '@utils/httpClient.js';

export const getContentCalendar = (profileId, from, to, types) =>
  httpClient.get(`api/profiles/${profileId}/content-calendar`, {
    params: { from, to, types },
  });

export const getUpcoming = (profileId, limit = 5) =>
  httpClient.get(`api/profiles/${profileId}/scheduled-tasks/upcoming`, {
    params: { limit },
  });

export const getSchedulerStats = (profileId) => httpClient.get(`api/profiles/${profileId}/scheduled-tasks/stats`);

export const getRecurrencePreview = (params) => httpClient.get(`api/scheduled-tasks/recurrence-preview`, { params });

export const createScheduledTask = (profileId, data) => httpClient.post(`api/profiles/${profileId}/scheduled-tasks`, data);

export const deleteScheduledTask = (profileId, taskId) => httpClient.delete(`api/profiles/${profileId}/scheduled-tasks/${taskId}`);

export const rescheduleScheduledTask = (profileId, taskId, data) => httpClient.patch(`api/profiles/${profileId}/scheduled-tasks/${taskId}/reschedule`, data);
